// generated from 105 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const emailUnsubscribedSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("email_unsubscribed_since_filter"),
  comparison_key: z.enum([
    "3", // 82 (78.10%)
    "4", // 11 (10.48%)
    "5", // 7 (6.67%)
    "6", // 5 (4.76%)
  ]),
  display_name: z.string(),
  // undefined: 68 (64.76%), defined 37 (35.24%)
  raw_value: z
    .union([
      // number samples: 14 (37.84%)
      // integer: 13 (92.86%)
      // avg: 9.22, min: 0, max: 56
      z.number().min(0),
      // string samples: 23 (62.16%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 16 (15.24%)
    // integer: 14 (87.50%)
    // avg: 9.94, min: 0, max: 56
    z.number().min(0),
    // string samples: 89 (84.76%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
